import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withKeys as _withKeys, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-932f32f8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "auth-card"
};
const _hoisted_2 = {
  class: "auth-story"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "story-brand"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "story-mark"
}, "A"), /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("strong", null, "Allen Blog"), /*#__PURE__*/_createElementVNode("small", null, "IDEAS · CODE · LIFE")])], -1));
const _hoisted_4 = {
  class: "story-copy"
};
const _hoisted_5 = {
  class: "story-kicker"
};
const _hoisted_6 = {
  class: "story-points"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "story-colophon",
  "aria-hidden": "true"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "colophon-rule"
}), /*#__PURE__*/_createElementVNode("span", {
  class: "colophon-word"
}, "Read. Think. Create."), /*#__PURE__*/_createElementVNode("small", null, "阅读有回响，记录有归处。")], -1));
const _hoisted_8 = {
  class: "auth-content"
};
const _hoisted_9 = {
  key: 0,
  class: "auth-section login-section",
  "aria-label": "登录账户"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("header", {
  class: "section-head"
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", {
  class: "section-kicker"
}, "MEMBER ACCESS"), /*#__PURE__*/_createElementVNode("h1", null, "欢迎回来"), /*#__PURE__*/_createElementVNode("p", null, "登录账号，继续上次的阅读与创作。")])], -1));
const _hoisted_11 = {
  class: "method-tabs",
  role: "group",
  "aria-label": "登录方式"
};
const _hoisted_12 = ["aria-pressed"];
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂未开放", -1));
const _hoisted_14 = ["disabled"];
const _hoisted_15 = {
  class: "verify-control"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "短信登录", -1));
const _hoisted_17 = {
  key: 2,
  class: "method-notice",
  role: "status"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "还没有账号？", -1));
const _hoisted_19 = {
  key: 1,
  class: "auth-section register-section",
  "aria-label": "创建账户"
};
const _hoisted_20 = {
  class: "section-head register-head"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", {
  class: "section-kicker"
}, "CREATE ACCOUNT"), /*#__PURE__*/_createElementVNode("h1", null, "创建新账号"), /*#__PURE__*/_createElementVNode("p", null, "让想法有一个落脚的地方。填写以下资料，开始记录。")], -1));
const _hoisted_22 = {
  class: "profile-row"
};
const _hoisted_23 = ["src"];
const _hoisted_24 = {
  key: 2,
  class: "avatar-edit"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("strong", null, [/*#__PURE__*/_createTextVNode("个人头像 "), /*#__PURE__*/_createElementVNode("span", {
  class: "optional-label"
}, "选填")]), /*#__PURE__*/_createElementVNode("p", null, "支持 JPG、PNG、WebP，文件不超过 2MB。")], -1));
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "form-divider"
}, [/*#__PURE__*/_createElementVNode("span", null, "账户资料")], -1));
const _hoisted_27 = {
  class: "register-grid"
};
const _hoisted_28 = {
  class: "register-actions"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "注册成功后，使用新账号登录即可。", -1));
const _hoisted_30 = ["disabled"];
import { computed, reactive, ref } from "vue";
import { useStore } from "vuex";
import { ArrowLeft, ArrowRight, Check, Iphone, Key, Loading, Lock, Upload, User } from "@element-plus/icons-vue";
import { loginApi, registerApi } from "@/request/api/user";
import { resolveUploadedFileUrl, uploadAvatar } from "@/request/api/upload";
import { applyUserAvatarFallback } from "@/utils/defaultImages";
import EventBus from "@/utils/EventBus";
import { getTokenExpiration } from "@/utils/tokenExpiration";
import feedback from "@/services/feedback";
export default {
  __name: 'AuthAccess',
  setup(__props) {
    const store = useStore();
    const screen = ref("login");
    const loginMethod = ref("password");
    const loginLoading = ref(false);
    const registerLoading = ref(false);
    const avatarLoading = ref(false);
    const passwordFormRef = ref(null);
    const registerFormRef = ref(null);
    const passwordForm = reactive({
      name: "",
      password: ""
    });
    const phoneForm = reactive({
      telephone: "",
      verifyCode: ""
    });
    const registerForm = reactive({
      id: "",
      nickName: "",
      name: "",
      sex: "1",
      password: "",
      avtor: "",
      telephone: "",
      email: "",
      profile: "",
      creatTime: "",
      updateTime: "",
      creatBy: "",
      updateBy: "",
      status: "",
      isdelete: ""
    });
    const storyPoints = computed(() => screen.value === "login" ? ["继续未完成的内容创作", "管理个人资料与文章", "同步账户访问状态"] : ["建立个人内容空间", "发布并管理原创文章", "随时完善个人资料"]);
    const loginRules = {
      name: [{
        required: true,
        message: "请输入用户名",
        trigger: "blur"
      }],
      password: [{
        required: true,
        message: "请输入密码",
        trigger: "blur"
      }]
    };
    const registerRules = {
      name: [{
        required: true,
        message: "请输入用户名",
        trigger: "blur"
      }, {
        min: 3,
        max: 32,
        message: "长度应为 3–32 个字符",
        trigger: "blur"
      }],
      nickName: [{
        required: true,
        message: "请输入昵称",
        trigger: "blur"
      }],
      telephone: [{
        required: true,
        message: "请输入手机号",
        trigger: "blur"
      }, {
        pattern: /^1[3-9]\d{9}$/,
        message: "手机号格式不正确",
        trigger: "blur"
      }],
      verifyCode: [{
        required: true,
        message: "请输入验证码",
        trigger: "blur"
      }],
      email: [{
        required: true,
        message: "请输入邮箱",
        trigger: "blur"
      }, {
        type: "email",
        message: "邮箱格式不正确",
        trigger: "blur"
      }],
      password: [{
        required: true,
        message: "请输入密码",
        trigger: "blur"
      }, {
        min: 8,
        max: 72,
        message: "长度应为 8–72 个字符",
        trigger: "blur"
      }]
    };
    const openRegister = () => {
      screen.value = "register";
    };
    const openLogin = () => {
      screen.value = "login";
      loginMethod.value = "password";
    };
    const showSmsPending = () => {
      feedback.info({
        title: "功能建设中",
        message: "短信验证码登录暂未开放，请先使用密码登录。"
      });
    };
    const beforeAvatarUpload = file => {
      const isImage = ["image/jpeg", "image/png", "image/webp"].includes(file.type);
      const isLt2M = file.size < 2 * 1024 * 1024;
      if (!isImage) {
        feedback.error({
          title: "文件格式不支持",
          message: "头像仅支持 JPG、PNG 或 WebP 格式。"
        });
        return false;
      }
      if (!isLt2M) {
        feedback.error({
          title: "图片过大",
          message: "头像文件不能超过 2MB。"
        });
        return false;
      }
      return true;
    };
    const handleAvatarUpload = async ({
      file
    }) => {
      avatarLoading.value = true;
      try {
        const formData = new FormData();
        formData.append("file", file);
        const response = await uploadAvatar(formData);
        registerForm.avtor = resolveUploadedFileUrl(response);
        feedback.success({
          title: "头像已上传",
          message: "注册后仍可在个人中心继续修改。"
        });
      } catch (error) {
        console.error("头像上传失败:", error);
      } finally {
        avatarLoading.value = false;
      }
    };
    const submitPasswordLogin = async () => {
      if (loginLoading.value) return;
      const valid = await passwordFormRef.value?.validate().catch(() => false);
      if (!valid) {
        feedback.warning({
          title: "信息不完整",
          message: "请检查用户名和密码后再登录。"
        });
        return;
      }
      loginLoading.value = true;
      try {
        const response = await loginApi(passwordForm);
        const user = response?.data;
        if (!user?.token) throw new Error("登录响应缺少 token");
        const expireTime = getTokenExpiration(user.token);
        if (!Number.isFinite(expireTime) || expireTime <= Date.now()) {
          feedback.error({
            title: "无法建立登录状态",
            message: "登录凭证已过期或缺少有效的过期时间，请检查设备时间后重新登录。"
          });
          return;
        }
        store.commit("setToken", {
          token: user.token,
          expireTime
        });
        if (!store.getters.isTokenValid) {
          feedback.error({
            title: "登录状态保存失败",
            message: "请重新登录后再试。"
          });
          return;
        }
        window.localStorage.setItem("user", JSON.stringify(user));
        feedback.success({
          title: "登录成功",
          message: `欢迎回来，${user.nickName || user.name || "用户"}。`
        });
        EventBus.emit("message-sent");
        EventBus.emit("auth-state-changed");
      } catch (error) {
        console.error("登录失败:", error);
      } finally {
        loginLoading.value = false;
      }
    };
    const submitRegister = async () => {
      if (registerLoading.value || avatarLoading.value) return;
      const valid = await registerFormRef.value?.validate().catch(() => false);
      if (!valid) {
        feedback.warning({
          title: "信息不完整",
          message: "请检查标记出的注册字段。"
        });
        return;
      }
      registerLoading.value = true;
      try {
        const now = new Date().toISOString();
        registerForm.creatTime = now;
        registerForm.updateTime = now;
        await registerApi(registerForm);
        passwordForm.name = registerForm.name;
        passwordForm.password = "";
        feedback.success({
          title: "账号创建成功",
          message: "请使用新账号登录。"
        });
        openLogin();
      } catch (error) {
        console.error("注册失败:", error);
      } finally {
        registerLoading.value = false;
      }
    };
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_radio_button = _resolveComponent("el-radio-button");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["auth-experience magazine-page", {
          'is-register': screen.value === 'register'
        }])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("aside", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(screen.value === "login" ? "WELCOME BACK" : "JOIN THE COMMUNITY"), 1), _createElementVNode("h2", null, _toDisplayString(screen.value === "login" ? "好文字，值得再次相遇。" : "从这里，写下你的第一篇。"), 1), _createElementVNode("p", null, _toDisplayString(screen.value === "login" ? "收藏让你停留的文章，留下读后的思考，也继续自己的创作。" : "以读者的好奇出发，用自己的文字记录技术、生活与每一次发现。"), 1), _createElementVNode("ul", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(storyPoints.value, point => {
        return _openBlock(), _createElementBlock("li", {
          key: point
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Check))]),
          _: 1
        }), _createElementVNode("span", null, _toDisplayString(point), 1)]);
      }), 128))])]), _hoisted_7]), _createElementVNode("main", _hoisted_8, [screen.value === 'login' ? (_openBlock(), _createElementBlock("section", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, [_createElementVNode("button", {
        type: "button",
        "aria-pressed": loginMethod.value === 'password',
        class: _normalizeClass({
          active: loginMethod.value === 'password'
        }),
        onClick: _cache[0] || (_cache[0] = $event => loginMethod.value = 'password')
      }, " 密码登录 ", 10, _hoisted_12), _createElementVNode("button", {
        type: "button",
        "aria-pressed": false,
        disabled: "",
        title: "短信登录暂未开放，请使用密码登录",
        class: _normalizeClass({
          active: loginMethod.value === 'sms'
        })
      }, [_createTextVNode(" 短信登录 "), _hoisted_13], 2)]), loginMethod.value === 'password' ? (_openBlock(), _createBlock(_component_el_form, {
        key: 0,
        ref_key: "passwordFormRef",
        ref: passwordFormRef,
        model: passwordForm,
        rules: loginRules,
        class: "auth-form",
        "label-position": "top",
        "hide-required-asterisk": "",
        onSubmit: _withModifiers(submitPasswordLogin, ["prevent"])
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "用户名",
          prop: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: passwordForm.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => passwordForm.name = $event),
            modelModifiers: {
              trim: true
            },
            "prefix-icon": _unref(User),
            autocomplete: "username",
            placeholder: "输入用户名",
            size: "large"
          }, null, 8, ["modelValue", "prefix-icon"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "密码",
          prop: "password"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: passwordForm.password,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => passwordForm.password = $event),
            "prefix-icon": _unref(Lock),
            autocomplete: "current-password",
            placeholder: "输入登录密码",
            "show-password": "",
            size: "large",
            type: "password",
            onKeyup: _withKeys(submitPasswordLogin, ["enter"])
          }, null, 8, ["modelValue", "prefix-icon"])]),
          _: 1
        }), _createElementVNode("button", {
          class: "primary-action",
          type: "submit",
          disabled: loginLoading.value
        }, [loginLoading.value ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          class: "is-loading"
        }, {
          default: _withCtx(() => [_createVNode(_unref(Loading))]),
          _: 1
        })) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(loginLoading.value ? "正在登录…" : "登录账户"), 1), !loginLoading.value ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 1
        }, {
          default: _withCtx(() => [_createVNode(_unref(ArrowRight))]),
          _: 1
        })) : _createCommentVNode("", true)], 8, _hoisted_14)]),
        _: 1
      }, 8, ["model"])) : (_openBlock(), _createBlock(_component_el_form, {
        key: 1,
        model: phoneForm,
        rules: registerRules,
        class: "auth-form",
        "label-position": "top",
        "hide-required-asterisk": ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "手机号",
          prop: "telephone"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: phoneForm.telephone,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => phoneForm.telephone = $event),
            modelModifiers: {
              trim: true
            },
            "prefix-icon": _unref(Iphone),
            inputmode: "tel",
            autocomplete: "tel",
            placeholder: "输入手机号",
            size: "large"
          }, null, 8, ["modelValue", "prefix-icon"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "验证码",
          prop: "verifyCode"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_input, {
            modelValue: phoneForm.verifyCode,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => phoneForm.verifyCode = $event),
            modelModifiers: {
              trim: true
            },
            "prefix-icon": _unref(Key),
            inputmode: "numeric",
            placeholder: "输入验证码",
            size: "large"
          }, null, 8, ["modelValue", "prefix-icon"]), _createElementVNode("button", {
            class: "secondary-action code-action",
            type: "button",
            onClick: showSmsPending
          }, "获取验证码")])]),
          _: 1
        }), _createElementVNode("button", {
          class: "primary-action",
          type: "button",
          onClick: showSmsPending
        }, [_hoisted_16, _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(ArrowRight))]),
          _: 1
        })])]),
        _: 1
      }, 8, ["model"])), loginMethod.value === 'sms' ? (_openBlock(), _createElementBlock("p", _hoisted_17, " 短信登录暂未开放，请切换至密码登录。 ")) : _createCommentVNode("", true), _createElementVNode("footer", {
        class: "auth-footer"
      }, [_hoisted_18, _createElementVNode("button", {
        type: "button",
        onClick: openRegister
      }, "创建新账号")])])) : (_openBlock(), _createElementBlock("section", _hoisted_19, [_createElementVNode("header", _hoisted_20, [_hoisted_21, _createElementVNode("button", {
        class: "back-action",
        type: "button",
        onClick: openLogin
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(ArrowLeft))]),
        _: 1
      }), _createTextVNode(" 返回登录 ")])]), _createVNode(_component_el_form, {
        ref_key: "registerFormRef",
        ref: registerFormRef,
        model: registerForm,
        rules: registerRules,
        class: "register-form",
        "label-position": "top",
        "hide-required-asterisk": "",
        onSubmit: _withModifiers(submitRegister, ["prevent"])
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_22, [_createVNode(_component_el_upload, {
          class: "avatar-uploader",
          "show-file-list": false,
          accept: "image/jpeg,image/png,image/webp",
          "before-upload": beforeAvatarUpload,
          "http-request": handleAvatarUpload,
          action: ""
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: _normalizeClass(["avatar-control", {
              uploaded: registerForm.avtor
            }])
          }, [registerForm.avtor ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: registerForm.avtor,
            alt: "注册头像",
            onError: _cache[5] || (_cache[5] = (...args) => _unref(applyUserAvatarFallback) && _unref(applyUserAvatarFallback)(...args))
          }, null, 40, _hoisted_23)) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [avatarLoading.value ? (_openBlock(), _createBlock(_component_el_icon, {
            key: 0,
            class: "is-loading"
          }, {
            default: _withCtx(() => [_createVNode(_unref(Loading))]),
            _: 1
          })) : (_openBlock(), _createBlock(_component_el_icon, {
            key: 1
          }, {
            default: _withCtx(() => [_createVNode(_unref(Upload))]),
            _: 1
          })), _createElementVNode("span", null, _toDisplayString(avatarLoading.value ? "上传中…" : "上传头像"), 1)], 64)), registerForm.avtor ? (_openBlock(), _createElementBlock("span", _hoisted_24, [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Upload))]),
            _: 1
          })])) : _createCommentVNode("", true)], 2)]),
          _: 1
        }), _hoisted_25]), _hoisted_26, _createElementVNode("div", _hoisted_27, [_createVNode(_component_el_form_item, {
          label: "用户名",
          prop: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: registerForm.name,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => registerForm.name = $event),
            modelModifiers: {
              trim: true
            },
            autocomplete: "username",
            placeholder: "3–32 个字符",
            size: "large"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "密码",
          prop: "password"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: registerForm.password,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => registerForm.password = $event),
            autocomplete: "new-password",
            placeholder: "8–72 个字符",
            "show-password": "",
            size: "large",
            type: "password"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "昵称",
          prop: "nickName"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: registerForm.nickName,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => registerForm.nickName = $event),
            modelModifiers: {
              trim: true
            },
            placeholder: "对外展示的名字",
            size: "large"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "手机号",
          prop: "telephone"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: registerForm.telephone,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => registerForm.telephone = $event),
            modelModifiers: {
              trim: true
            },
            autocomplete: "tel",
            inputmode: "tel",
            placeholder: "11 位手机号",
            size: "large"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "邮箱",
          prop: "email"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: registerForm.email,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => registerForm.email = $event),
            modelModifiers: {
              trim: true
            },
            autocomplete: "email",
            inputmode: "email",
            placeholder: "name@example.com",
            size: "large"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "性别",
          prop: "sex"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: registerForm.sex,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => registerForm.sex = $event),
            class: "gender-control"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_button, {
              label: "1"
            }, {
              default: _withCtx(() => [_createTextVNode("男")]),
              _: 1
            }), _createVNode(_component_el_radio_button, {
              label: "0"
            }, {
              default: _withCtx(() => [_createTextVNode("女")]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_28, [_hoisted_29, _createElementVNode("button", {
          class: "primary-action register-submit",
          type: "submit",
          disabled: registerLoading.value || avatarLoading.value
        }, [registerLoading.value ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          class: "is-loading"
        }, {
          default: _withCtx(() => [_createVNode(_unref(Loading))]),
          _: 1
        })) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(registerLoading.value ? "正在创建…" : "创建账号"), 1), !registerLoading.value ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 1
        }, {
          default: _withCtx(() => [_createVNode(_unref(ArrowRight))]),
          _: 1
        })) : _createCommentVNode("", true)], 8, _hoisted_30)])]),
        _: 1
      }, 8, ["model"])]))])])], 2);
    };
  }
};